import { theme } from '@approvalmax/theme';
import { Container } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const StyledContainer = styled(Container)`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;

    @media (max-width: ${theme.container.breakpoint.medium}) {
        flex-direction: column-reverse;
        align-items: center;
        row-gap: 80px;
    }
`;
